import { API } from '@/api'

export const getAllPersons = () => API.get('/persons/')
export const createPerson = (payload) => API.post('/persons/', payload)
export const getPersonById = (id) => API.get(`/persons/${id}/`)
export const updatePersonById = (id, payload) => API.put(`/persons/${id}/`, payload)
export const deletePersonById = (id) => API.delete(`/persons/${id}/`)
